/** @jsxImportSource @emotion/react */

import { authStoreUserTournamentId } from 'modules/auth/store/selectors';
import { Pages } from 'modules/navigation/domain/enums/pages';
import { useCallback, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useFetchActivePlan } from 'shared/hooks/fetchering/use-fetch-active-plan';

import { useDispatchWithToast } from 'store/use-dispatch-with-toast';
import { UDText } from 'ud-ui/components';
import UDBreadcrumbs from 'ud-ui/components/breadcrumbs';
import { useMainLayout } from 'modules/app-shell/ui/layout/context';
import { UpsertLocationInput } from 'modules/locations/domain/interfaces/actions';
import { upsertLocation } from 'modules/locations/store/actions';
import { selectProcess } from 'modules/locations/store/selectors';
import LocationForm from '../components/location-form';

function LocationCreatePage() {
  const navigate = useNavigate();
  const dispatchWithToast = useDispatchWithToast();
  // Раньше здесь читался флаг загрузки перечня локаций — к форме создания он отношения не имел.
  const { isProcessing } = useSelector(selectProcess);
  const tournamentId = useSelector(authStoreUserTournamentId);
  const { setHeaderContent } = useMainLayout();
  const { data: activePlan, isFetching: isPlanFetching } = useFetchActivePlan();

  const breadcrumb = useMemo(
    () => (
      <UDBreadcrumbs
        className="my-10"
        breadcrumbs={[
          { label: 'Локации', to: Pages.LOCATIONS.INDEX },
          { label: 'Добавление локации', to: Pages.LOCATIONS.CREATE },
        ]}
      />
    ),
    [],
  );

  const handleSubmit = useCallback(
    async (values: UpsertLocationInput) => {
      if (!tournamentId) {
        console.error('No tournament selected');
        return;
      }

      const locationData: UpsertLocationInput = {
        ...values,
        tournamentId,
      };

      const result = await dispatchWithToast(upsertLocation(locationData), {
        success: 'Локация успешно сохранена',
        error: 'Не удалось сохранить локацию',
      });
      if (!result) return;

      navigate(Pages.LOCATIONS.builders.edit(result.id));
    },
    [dispatchWithToast, navigate, tournamentId],
  );

  useEffect(() => {
    setHeaderContent(breadcrumb);
    return () => setHeaderContent(null);
  }, [breadcrumb, setHeaderContent]);

  return (
    <>
      <div className="w-full px-6 py-6">
        <UDText type="headline" className="mr-10">
          Локация для проведения турнира
        </UDText>
      </div>
      <div className="border-surfacePlatinum20 flex w-full items-center border-b px-6" />
      <div className={'w-full px-6 pt-6'}>
        <LocationForm
          isLoading={isProcessing || isPlanFetching}
          onSubmit={handleSubmit}
          tournamentId={tournamentId || undefined}
          action="create"
          isAvailableFeatures={Boolean(activePlan)}
        />
      </div>
    </>
  );
}

export default LocationCreatePage;
